import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _RemoveChoiceButton;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { IconTrashLine } from '@instructure/ui-icons';
import { jsx } from '@instructure/emotion';
import { IconButton } from '@instructure/ui-buttons';
import { omitProps } from '@instructure/ui-react-utils';
import t from '@instructure/quiz-i18n/es/format-message';
var RemoveChoiceButton = /*#__PURE__*/function (_Component) {
  function RemoveChoiceButton() {
    var _this;
    _classCallCheck(this, RemoveChoiceButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RemoveChoiceButton, [].concat(args));
    _defineProperty(_this, "button", null);
    // ================
    //   PUBLIC UTILS
    // ================
    _defineProperty(_this, "focus", function () {
      _this.button.focus();
    });
    // ============
    //   HANDLERS
    // ============
    _defineProperty(_this, "handleRef", function (node) {
      _this.button = node;
    });
    _defineProperty(_this, "handleClick", function (event) {
      _this.props.onRemoveChoice(_this.props.choiceId, event);
      _this.props.onClick(event);
    });
    return _this;
  }
  _inherits(RemoveChoiceButton, _Component);
  return _createClass(RemoveChoiceButton, [{
    key: "render",
    value:
    // ===========
    //   RENDERS
    // ===========

    function render() {
      var _this$props = this.props,
        buttonSize = _this$props.buttonSize,
        screenReaderText = _this$props.screenReaderText;
      return jsx(IconButton, Object.assign({}, omitProps(this.props, this.constructor.propTypes), {
        withBackground: false,
        withBorder: false,
        name: this.props.choiceId,
        onClick: this.handleClick,
        ref: this.handleRef,
        size: buttonSize,
        renderIcon: IconTrashLine,
        screenReaderLabel: screenReaderText || t('Remove Distractor'),
        "data-automation": this.props.automationData || "sdk-remove-distractor-".concat(this.props.choiceId, "-button")
      }));
    }
  }]);
}(Component);
_RemoveChoiceButton = RemoveChoiceButton;
_defineProperty(RemoveChoiceButton, "displayName", 'RemoveChoiceButton');
_defineProperty(RemoveChoiceButton, "componentId", "Quizzes".concat(_RemoveChoiceButton.displayName));
_defineProperty(RemoveChoiceButton, "propTypes", {
  buttonSize: PropTypes.oneOf(['small', 'medium', 'large']),
  choiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onRemoveChoice: PropTypes.func,
  onClick: PropTypes.func,
  screenReaderText: PropTypes.string,
  styles: PropTypes.object,
  automationData: PropTypes.string
});
_defineProperty(RemoveChoiceButton, "defaultProps", {
  buttonSize: 'medium',
  choiceId: void 0,
  screenReaderText: null,
  onRemoveChoice: function onRemoveChoice() {},
  onClick: function onClick() {}
});
export { RemoveChoiceButton as default };